import ApiService from './ApiService';

class TradeProcessHistoryService {
    async getTradeProcessHistory(payload) {
        try {
          const response = await ApiService.call(
            '/secured/get_trade_process_history',
            'POST',
            payload,
          );
    
          console.log(response);
    
          return {
            success: true,
            data: response.result,
            total: response.totalCount
          };
        } catch (error) {
          let data = error.response ? error.response.data : error;
          return {
            success: false,
            code: data.error || data.code,
            message: data.message,
          };
        }
    }
    async getMatchTradeList(payload) {
      try {
        const response = await ApiService.call('/secured/get_trade_matching_record_list', 'POST', payload);
        let data = response;
  
        console.log(data);
  
        return {
          matchTradeList: data.tradeMatchingRecordDataList,
          success: true,
        };
      } catch (error) {
        let data = error.response ? error.response.data : error;
        return {
          success: false,
          code: data.error || data.code,
          message: data.message,
        };
      }
    }
}
export default new TradeProcessHistoryService();
